import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import FctvaComponent from '../../../components/Mouvement/Panel/FctvaComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class FctvaPanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.FCTVA;
    this.icon = { name: 'euro' };
  }

  getLibelle = () => 'FCTVA';

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.fctva);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <FctvaComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default FctvaPanel;
